export default {
	namespaced : true,
	state : {
		settings : {
			userInfos : {
				clientNb : 'SH-12345',
				profilImg: require('@/assets/images/profil1.jpg'),
				userMail: 'jane.doe@entreprise.com',
			},
			historyInvoice : {
				tableValue: [
					{
					  name: '1412665413',
					  date: '15-06-2021',
					  amount: 250,
					  status: 'En cours',
					  type: '',
					},
					{
					  name: '1412665413',
					  date: '15-06-2021',
					  amount: 300,
					  status: 'Payée',
					  type: '',
					},
					{
					  name: '1412665413',
					  date: '15-06-2021',
					  amount: 320,
					  status: 'Erreur',
					  type: '',
					},
					{
					  name: '1412665413',
					  date: '15-06-2021',
					  amount: 350,
					  status: 'Payée',
					  type: '',
					},
				],
			}
		  	},
		routers: {
			routerList: [
				{
					title : "Wild & The Moon - Saint Honoré",
					subtitle : "Paris 8éme, France",
					boxReference: "12345"
				},
				{
					title : "Wild & The Moon - République",
					subtitle : "Paris 8éme, France",
					boxReference: "654321"
				},
			],
			showRouterLoader: false,
			routerIsAdded: false,
			routerAddingError: false,
			cancelBtnIsDisabled: false,
			validateBtnIsDisabled: false,

		},
		shops: {
			boxReference: '12345',
			
		}
	},
	mutations : {
		addNewRouter(state, value) {
			state.routers.showRouterLoader = true;
			state.routers.cancelBtnIsDisabled = true;
			state.routers.validateBtnIsDisabled = true;
			setTimeout(() => {
				state.routers.routerList.push(value);
				state.routers.showRouterLoader = false
				//Simulation d'un retour de l'api 
				// var res = 300;
				var res = 200;
				if(res === 200){
					return state.routers.routerIsAdded = true;
				}
				else{ return state.routers.routerAddingError = true } 
			  }, 3000)
		},
		initialize(state) {
			state.routers.showRouterLoader = false;
			state.routers.cancelBtnIsDisabled = false;
			state.routers.validateBtnIsDisabled = false;
			state.routers.routerIsAdded = false;
		}
	},
	actions : {

	}
};